import {
  checkSpace as check,
  checkAllSpaces as checkAll,
  deleteSpaces,
  filterSpace as filter,
  addSpaceTag as insertSpaceTag,
  deleteSpaceTag as removeTag,
  setLegalCapacity,
  setSafeCapacity,
  setSpaces,
  setTargetCapacity,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { Space } from "../../types";

const useSpaces = () => {
  const spacesState = useSelector((state: any) => state.spaces);
  const [storedSpaces, setStoredSpaces] = useState<any>(spacesState);
  const dispatch = useDispatch();

  useEffect(() => {
    setStoredSpaces(spacesState);
  }, [spacesState]);

  const storeSpaces = (_spaces: Space[]) => {
    dispatch(setSpaces(_spaces));
  };

  const checkSpace = (id: string, checked: boolean) => {
    dispatch(check(id, checked));
  };

  const filterSpace = (id: string, filtered: boolean) => {
    dispatch(filter(id, filtered));
  };

  const checkAllSpaces = (checked: boolean) => {
    dispatch(checkAll(checked));
  };

  const removeSpaces = () => {
    dispatch(deleteSpaces());
  };

  const setSpaceSafeCapacity = (id: string, capacity: number) => {
    dispatch(setSafeCapacity(id, capacity));
  };

  const setSpaceTargetCapacity = (id: string, capacity: number) => {
    dispatch(setTargetCapacity(id, capacity));
  };

  const setSpaceLegalCapacity = (id: string, capacity: number) => {
    dispatch(setLegalCapacity(id, capacity));
  };

  const addSpaceTag = (id: string, tag: string) => {
    dispatch(insertSpaceTag(id, tag));
  };

  const deleteSpaceTag = (id: string, tag: string) => {
    dispatch(removeTag(id, tag));
  };

  return {
    spaces: storedSpaces,
    removeSpaces,
    storeSpaces,
    checkSpace,
    filterSpace,
    checkAllSpaces,
    setSpaceTargetCapacity,
    setSpaceLegalCapacity,
    setSpaceSafeCapacity,
    addSpaceTag,
    deleteSpaceTag,
  };
};

export default useSpaces;
